export const onboardingTour = {
    module: 'onboarding',
    title: 'Onboarding Tour',
    title_vi: 'Tour Bắt đầu sử dụng',
    description: 'As the Compliance Trainer (P-VN-02), deliver training via guided tours, load realistic sample data for hands-on exercises, and run the setup wizard for quick-start scenarios.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Compliance Trainer (P-VN-02), deliver training via guided tours, load realistic sample data for hands-on exercises, and run the setup wizard for quick-start scenarios.',
    estimated_duration_seconds: 36,
    steps: [
        {
            step_id: 'ob_tours_gallery',
            navigate_to: '/admin/onboarding/tours',
            target: '.dm-page',
            title: 'Tours Gallery',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Tours Gallery',
            description: 'As the Compliance Trainer, you will use this gallery to deliver role-based training. Each tour teaches a specific compliance workflow -- assign the right tours to DPOs, auditors, and IT leads based on their responsibilities.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Compliance Trainer, you will use this gallery to deliver role-based training. Each tour teaches a specific compliance workflow -- assign the right tours to DPOs, auditors, and IT leads based on their responsibilities.',
            position: 'bottom',
        },
        {
            step_id: 'ob_search_tours',
            target: 'input[placeholder]',
            title: 'Search Tours',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search Tours',
            description: 'Search by module name or keyword to find the right training tour. Use this to quickly locate tours for a specific compliance area like Rights Management or Incident Response.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search by module name or keyword to find the right training tour. Use this to quickly locate tours for a specific compliance area like Rights Management or Incident Response.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: 'input[placeholder]',
                value: 'Rights',
            },
        },
        {
            step_id: 'ob_tour_cards',
            target: '.dm-card:first-child',
            title: 'Tour Cards',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Tour Cards',
            description: 'Each card shows the tour description, step count, and estimated duration. Recommend shorter tours for quick-start scenarios and longer ones for comprehensive training sessions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each card shows the tour description, step count, and estimated duration. Recommend shorter tours for quick-start scenarios and longer ones for comprehensive training sessions.',
            position: 'bottom',
        },
        {
            step_id: 'ob_mode_toggle',
            target: '#mode-list',
            title: 'Tour Mode',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Tour Mode',
            description: 'Toggle between Auto-play (for demonstrations) and Interactive (for hands-on training where the learner controls the pace).',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Toggle between Auto-play (for demonstrations) and Interactive (for hands-on training where the learner controls the pace).',
            position: 'bottom',
        },
        {
            step_id: 'ob_sample_data',
            target: '[data-testid="sample-data-tab"]',
            title: 'Load Sample Data',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Load Sample Data',
            description: 'Populate the platform with realistic compliance data for training exercises. Sample data lets new team members practice with incidents, assessments, and requests without touching production records.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Populate the platform with realistic compliance data for training exercises. Sample data lets new team members practice with incidents, assessments, and requests without touching production records.',
            position: 'bottom',
        },
        {
            step_id: 'ob_sample_page',
            navigate_to: '/admin/onboarding/sample-data',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Sample Data Page',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Sample Data Page',
            description: 'Generate sample organizations, users, and compliance records for training scenarios. Clear the data from Platform Settings when training is complete.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate sample organizations, users, and compliance records for training scenarios. Clear the data from Platform Settings when training is complete.',
            position: 'bottom',
        },
        {
            step_id: 'ob_wizard',
            navigate_to: '/admin/onboarding/setup',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Setup Wizard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Setup Wizard',
            description: 'The setup wizard walks new organizations through initial configuration: company details, regulatory framework selection, and module activation. Ideal for quick-start onboarding scenarios.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: The setup wizard walks new organizations through initial configuration: company details, regulatory framework selection, and module activation. Ideal for quick-start onboarding scenarios.',
            position: 'bottom',
        },
        {
            step_id: 'ob_return_tours',
            navigate_to: '/admin/onboarding/tours',
            wait_for: '.dm-page',
            target: '.dm-page',
            title: 'Onboarding Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Onboarding Tour Complete',
            description: 'You can now deliver role-based training via guided tours, set up realistic practice environments with sample data, and run the setup wizard for quick-start onboarding of new organizations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now deliver role-based training via guided tours, set up realistic practice environments with sample data, and run the setup wizard for quick-start onboarding of new organizations.',
            position: 'top',
        },
    ],
};
//# sourceMappingURL=onboarding.js.map